export const MODAL_ERROR_OPEN = 'MODAL_ERROR_OPEN';
export const MODAL_ERROR_CLOSE = 'MODAL_ERROR_CLOSE';
